import { Activity } from '~/types/bootcamp'
import { selectCurrentActivityType } from '~/bootcamp/slices/bootcamp-activity.slice'
import { useAppSelector } from '~/redux/hooks'

export default function useGetActivityWorkloadLevel(activities: Activity[]): number {
  const activityType = useAppSelector(selectCurrentActivityType)
  const activity = activities.find((elem) => elem.type === activityType)
  return activity?.workLoadLevel || 1
}
